import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';

const ShortcutKey = ({ keybind, shadow = false, compact = false }) => {
  return /* @__PURE__ */ jsx("span", {
    className: clsx(!compact ? "font-semibold text-sm inline-flex justify-center items-center p-[2px] w-[19px] h-[18px] text-black bg-white rounded" : "text-gray-400", shadow && "shadow-md"),
    children: keybind
  });
};

export { ShortcutKey as default };
//# sourceMappingURL=ShortcutKey.js.map
